module.exports = {"id":"193250","name":"Marin Leovac","rating":"71","photo":"./data/images/photos/1/193250.png","club":{"name":"PAOK Salonique","logo":"./data/images/clubs/PAOKSalonique.png"},"positions":["DG","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarinLeovac0.json
// module id = 2775
// module chunks = 0